import { z } from "zod";

/**
 * Error-only schema for Amenities form (blocking validation)
 *
 * Contains only required field validation.
 * This validation blocks form submission.
 */
export const AmenitiesErrorSchema = z.object({
  amenities: z.array(z.string()).optional(),
});

/**
 * Warning-only schema for Amenities form (non-blocking recommendations)
 *
 * Contains UX recommendations that don't block submission.
 * These are shown immediately to guide users toward best practices.
 */
export const AmenitiesWarningSchema = z
  .object({
    amenities: z.array(z.string()).optional(),
  })
  .superRefine((data, ctx) => {
    // CLIENT WARNING: Recommend adding amenities
    if (!data.amenities || data.amenities.length === 0) {
      ctx.addIssue({
        code: "custom",
        message:
          "Consider selecting some amenities to make your listing more attractive to potential tenants.",
        severity: "warning",
        path: ["amenities"],
      });
    }
  })
  .superRefine((data, ctx) => {
    // CLIENT WARNING: Recommend adding more amenities for completeness
    if (
      data.amenities &&
      data.amenities.length > 0 &&
      data.amenities.length < 3
    ) {
      ctx.addIssue({
        code: "custom",
        message:
          "Consider adding at least 3 amenities to provide a complete picture of your property's features",
        severity: "warning",
        path: ["amenities"],
      });
    }
  });

export type AmenitiesFormData = z.infer<typeof AmenitiesErrorSchema>;
